import { useEffect, useState } from "react";

export default function BrandLoader({ onFinish, minMs = 1700 }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!onFinish) return;
    const t1 = setTimeout(() => setFading(true), minMs);
    const t2 = setTimeout(() => onFinish(), minMs + 650);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [minMs, onFinish]);

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{
        background: "radial-gradient(circle at 50% 42%, #0e1219 0%, #05060a 60%, #000 100%)",
        opacity: fading ? 0 : 1,
        transition: "opacity .6s ease",
        pointerEvents: fading ? "none" : "auto",
      }}
    >
      <div className="relative flex items-center justify-center">
        {/* Pulsing gold halo behind the logo */}
        <div
          className="gold-glow absolute rounded-full"
          style={{
            width: 320, height: 320,
            background: "radial-gradient(circle, rgba(245,158,11,0.35) 0%, rgba(217,119,6,0.12) 40%, transparent 70%)",
            filter: "blur(24px)",
          }}
        />
        <img
          src="/logo.jpg"
          alt="Global Ore Exchange"
          className="relative w-72 max-w-[76vw]"
          style={{ mixBlendMode: "screen" }}
        />
      </div>

      {/* Thin gold progress bar */}
      <div className="load-bar-track mt-8 h-[3px] w-52 max-w-[60vw] rounded-full" style={{ background: "rgba(245,158,11,0.12)" }}>
        <div className="load-bar-fill" />
      </div>
      <p className="mt-5 text-[11px] font-bold tracking-[0.35em]" style={{ color: "#8791A2" }}>
        COMMODITY EXCHANGE
      </p>
    </div>
  );
}
